export default [
    {
        path: '/',
        name: 'guest.login',
        component: () => import(/* webpackChunkName: "guests" */ '@/pages/index.vue'),
        meta: {
            guestRequired: true,
            loginRequired: false,
            permission: '*',
        },
    },
    {
        path: '/social/login',
        name: 'social.login',
        component: () => import(/* webpackChunkName: "guests" */ '@/pages/social/login/index.vue'),
        meta: {
            guestRequired: true,
            loginRequired: false,
            permission: '*',
        },
    },
    {
        path: '/guest/registration',
        name: 'guest.registration',
        component: () => import(/* webpackChunkName: "guests" */ '@/pages/guest/registration.vue'),
        meta: {
            guestRequired: true,
            loginRequired: false,
            permission: '*',
        },
    },
    {
        path: '/guest/verification',
        name: 'guest.verification',
        component: () => import(/* webpackChunkName: "guests" */ '@/pages/guest/verification.vue'),
        meta: {
            guestRequired: false,
            loginRequired: false,
            permission: '*',
        },
    },
    {
        path: '/guest/forgot-password',
        name: 'guest.forgot-password',
        component: () => import(/* webpackChunkName: "guests" */ '@/pages/guest/forgot-password.vue'),
        meta: {
            guestRequired: true,
            loginRequired: false,
            permission: '*',
        },
    },
    {
        path: '/guest/reset-password/:token',
        name: 'guest.reset-password',
        component: () => import(/* webpackChunkName: "guests" */ '@/pages/guest/reset-password/[token].vue'),
        meta: {
            guestRequired: false,
            loginRequired: false,
            permission: '*',
        },
    },
];
